module.exports = __webpack_public_path__ + "images/category_lp/watch/shape-right_51752a7108cb3929fc44587b77f39da1.png";